import { Controller } from "@hotwired/stimulus"

// Drives the CSV import column-mapping form on the review screen.
//
//   * toggleStrategy — shows the signed OR the in/out amount field group
//     depending on which "Amount strategy" radio is selected. Plain
//     synchronous class toggling — no timers (per AGENTS §6).
//   * notifySuccess — fired on `turbo:submit-end` after the remap request
//     completes, dispatching a `notification:show` toast rather than relying
//     on Rails flash (per AGENTS §5).
export default class extends Controller {
  static targets = ["signedFields", "inOutFields"]

  toggleStrategy(event) {
    const inOut = event.target.value === "in_out"

    if (this.hasSignedFieldsTarget) this.signedFieldsTarget.classList.toggle("hidden", inOut)
    if (this.hasInOutFieldsTarget)  this.inOutFieldsTarget.classList.toggle("hidden", !inOut)
  }

  notifySuccess(event) {
    if (!event.detail?.success) return

    window.dispatchEvent(new CustomEvent("notification:show", {
      detail: {
        title:   "Mapping updated",
        message: "The preview has been re-generated from your file.",
        type:    "success"
      }
    }))
  }
}
